import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from 'utils/user';
import { Event } from './types';

export const apiEvents = createApi({
  reducerPath: 'eventsApi',
  tagTypes: ['Event'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${getApiBaseUrl()}/`,
    credentials: 'include',
    prepareHeaders: (headers) => {
      headers.set('X-Client', 'web');
      return headers;
    },
  }),
  endpoints: builder => ({
    getEvents: builder.query<Event[], any>({
      query: ({
        type,
        objectiveId,
      }) => {
        return {
          url: 'events',
          params: {
            type,
            objectiveId,
          },
        };
      },
      transformResponse: (data: { events: Event[] }) => data.events,
      transformErrorResponse: (response: { status: string | number }) => response.status,
      providesTags: ['Event'],
    }),
  }),
});

export const {
  useLazyGetEventsQuery,
} = apiEvents;
